import React, { useEffect, useMemo, useRef, useState } from 'react';
import '../../../index.scss';

// material
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { isType, isType3, localeTw, userTypeList } from 'main_consts';

// ICON
import { FileCopy } from '@material-ui/icons';
import SaveIcon from '@material-ui/icons/Save';
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
// other
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { GridColDef } from '@material-ui/data-grid';
import { Iobject, Ioption } from 'main_type';
import { setLoadingRedux, setUserInfoRedux } from 'reducers/shareData/action';
import WarehouseModal from 'components/Modal/WareHouseModal';
import { IuserInfo } from 'reducers/shareData/types';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import DateOneSePickersTyping from 'components/DatePicker/DateOneSePickersTyping';
import Header from 'components/Header';
import { ColDef, GridOptions } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { QRCodeCanvas } from 'qrcode.react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Hidden,
  IconButton,
  TextField,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { isDate, isValid } from 'date-fns';
import { Autocomplete } from '@material-ui/lab';
import Select from '../../../components/Material/Select';
import Radio from '../../../components/Radio';
// component
import Menu, { IMenu } from '../../../components/Menu';
import {
  getDateDayPlus,
  getWarehouse,
  inputChange,
  radioChange,
  formatDate,
  selectChange,
  getFindDropDownList,
  getfindDropDownContainerNoList,
} from '../../../main_func';
import Input from '../../../components/Material/Input';
import { FormTitle, HVcGrid, VcEGrid, VcGrid } from '../../../components/Grid';
import {
  getLoginInfo,
  getSearch,
  postApiAndFunctionName,
  postSearch,
  snackBarRsp,
} from '../../../main_api';

import { Imaster, Iresult, IresultContainerNo, IresultQrCode } from './type';

/** 車輛入出站登錄維護 */
const CarRegisterMtn = (): JSX.Element => {
  const dispatch = useDispatch();
  const [formError, setFormError] = useState(false);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  useEffect(() => {
    let isMounted = true;

    const refreshLoginState = async () => {
      try {
        const response = await getLoginInfo();
        const result = response?.data as {
          status?: number;
          data?: Partial<IuserInfo>;
        };

        if (!isMounted || result?.status !== 0 || !result?.data) {
          return;
        }

        dispatch(setUserInfoRedux(result.data as IuserInfo));
      } catch (error) {
        // 未登入或 session 過期時，保留 guest 模式，不跳轉登入頁
        console.warn('login recheck failed:', error);
      }
    };

    refreshLoginState();

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  const menuProps: IMenu = {
    guest: true, // 設定 guest 參數為 true
  };
  const { enqueueSnackbar } = useSnackbar();
  // call login
  const masterDefaultValue: Imaster = {
    // 快遞倉站
    warehouse: 'TPEE011S',
    // userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
    //   ? locationCode
    //   : 'TPEE011S',
    // 主號
    enterTypeOut: '',
    // 分號
    enterTypeIn: 'N',
    // 日期
    enterDate: getDateDayPlus(),
    carNo: '',
    containerNo: '',
  };
  const resultDefaultValue: Iresult = {
    warehouse: '',
    enterTypeOut: '',
    enterTypeIn: 'N',
    carNo: '',
    regNo: '',
    containerNo: '',
    driver: '',
    driverNo: '',
    driverAide: '',
    driverAideNo: '',
    logisticName: '',
    enterStatus: '',
    remark: '',
    enterDate: getDateDayPlus(),
    vasnoNo: '*',
    truckNo: '',
    actionCode: '',
    loginUserid: '',
    mawb: '',
  };
  const apiName = 'carRegisterMtn';
  const [master, setMaster] = useState(masterDefaultValue);
  const [detail, setDetail] = useState(resultDefaultValue);
  const [random, setRamdom] = useState(Math.random());
  const [warehouseName, setWarehouseName] = useState('');
  const [loginUser, setLoginUser] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [openSearchField, setOpenSearchField] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const [colList, setColList] = useState<GridColDef[]>([]);
  const [randomValue, setRandomValue] = useState(Math.random());
  const [rowData, setRowData] = useState<IresultContainerNo[]>([]);
  const [enterstatusOptions, setEnterstatusOptions] = useState<Ioption[]>([]);
  const [containerNoOptions, setContainerNoOptions] = useState<string[]>([]);
  const [mawbOptions, setMawbOptions] = useState<string[]>([]);
  const [enterTypeInOptions, setEnterTypeInOptions] = useState<Ioption[]>([]);
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(false);

  const [openPopup, setOpenPopup] = useState(false);
  const [mawb, setMawb] = useState('');
  const [hawb, setHawb] = useState('');

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const [screenType, setScreenType] = useState('md 以上螢幕');
  useEffect(() => {
    if (isXs) {
      setScreenType('目前為 xs 螢幕');
      // 這裡可以加你要的動作
    } else if (isSm) {
      setScreenType('目前為 sm 螢幕');
      // 這裡可以加你要的動作
    } else {
      setScreenType('目前為 md 以上螢幕');
      // 這裡可以加你要的動作
    }
  }, [isXs, isSm]);

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setDetail(resultDefaultValue);

    setOpenSearchField(false);
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
    setOpenPopup(false);
    setMawb('');
    setHawb('');
  };
  useEffect(() => {
    const options: Ioption[] = [{ value: 'N', label: '提領出站' }];
    if (
      isType(userTypeList.admin, userType) ||
      isType(userTypeList.type1, userType) ||
      isType(userTypeList.type10, userType)
    ) {
      options.push({ value: 'Y', label: '空車進站' });
    }
    setEnterTypeInOptions(options);
    setMaster((prev) => ({
      ...prev,
      enterTypeIn: 'N',
    }));
    setDetail((prev) => ({
      ...prev,
      enterTypeIn: 'N',
    }));
  }, [userType]);

  const handleContainer = async (id: string) => {
    getfindDropDownContainerNoList(detail.enterDate, master.warehouse, '').then(
      (item) => {
        setContainerNoOptions(item);
      }
    );
  };

  const handleMawb = async (hawbValue: string) => {
    postApiAndFunctionName(apiName, 'findMawbNoByWorkimphwb', {
      warehouse: master.warehouse,
      hawbNo: hawbValue,
    }).then((item) => {
      if (!snackBarRsp(enqueueSnackbar, item) || item.data.status !== 0) {
        dispatch(setLoadingRedux(false));
        setMawbOptions([]);
        return;
      }

      const dataArr = Array.isArray(item.data.data) ? item.data.data : [];
      const list = dataArr.map((x: any) => x.mawbNo ?? '');

      // ✅ 放進 useState（型別符合 string[]）
      setMawbOptions(list);
    });
  };

  useEffect(() => {
    if (detail.enterDate && detail.enterDate.length === 8) {
      handleContainer(detail.enterDate);
    }
  }, [detail.enterDate]);

  // 以後要把 null / undefined 轉成空字串
  function cleanNulls<T extends Record<string, any>>(obj: T): T {
    return Object.fromEntries(
      Object.entries(obj).map(([k, v]) => [k, v ?? ''])
    ) as T;
  }
  const handleAdd = async (value: IresultQrCode | null) => {
    postApiAndFunctionName(apiName, 'createCarData', {
      warehouse: value ? value.locationCode : master.warehouse,
      driver: value ? value.driver : '',
      driverNo: value ? value.driverNo : '',
      carNo: value ? value.licensePlateNumber : '',
    }).then((item) => {
      if (!snackBarRsp(enqueueSnackbar, item) || item.data.status !== 0) {
        dispatch(setLoadingRedux(false));
        return;
      }

      const { data: dataTemp } = item.data;

      const data = dataTemp as Iresult;
      if (data) {
        setDetail(
          cleanNulls({
            ...resultDefaultValue,
            ...data,
          })
        );
        setOpenSearchField(true);
      }
    });
  };
  const handleSearchQRCode = async (value: string | null) => {
    postApiAndFunctionName(apiName, 'initial', {
      qrCodeData: value,
    }).then((item) => {
      if (!snackBarRsp(enqueueSnackbar, item) || item.data.status !== 0) {
        setFormError(true);
        setMaster((prev) => ({
          ...prev,
          warehouse: '',
        }));
        dispatch(setLoadingRedux(false));
        return;
      }
      const data = item.data.data as IresultQrCode;

      if (data && data.locationCode) {
        setLoginUser(data.loginUser);
        setMaster((prev) => ({
          ...prev,
          warehouse: data.locationCode,
          carNo: data.licensePlateNumber,
        }));
        if (data.driver && data.driverNo) {
          handleReset().then(() => {
            setMaster((prev) => ({
              ...prev,
              warehouse: data.locationCode,
              carNo: data.licensePlateNumber,
            }));

            handleAdd(data);
          });
        }
      }
    });
  };

  useEffect(() => {
    const list: Ioption[] = [
      { value: '1', label: '正常' },
      { value: '2', label: '取消' },
      { value: '3', label: '換車' },
    ];
    setEnterstatusOptions(list);

    const urlParams = new URLSearchParams(window.location.search);
    const urlQrcode = urlParams.get('value');

    handleSearchQRCode(urlQrcode);
  }, []);

  const getColumnDefs = (status: boolean): ColDef[] => {
    return [
      {
        // headerCheckboxSelection: true,
        // headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        lockPosition: true,
        headerName: '項次',
        field: 'itemNo',
        valueGetter: 'node.rowIndex',
        cellClass: 'locked-col',
        suppressNavigable: true,
        maxWidth: 100,
        filter: false,
        sortable: false,
        editable: false,
        valueFormatter: (data) => {
          return data.value + 1;
        },
      },
      {
        headerName: '車號',
        field: 'carNo',
        width: 300,
      },
      {
        headerName: '櫃號',
        field: 'containerNo',
        width: 300,
      },
      {
        headerName: '板箱號',
        field: 'truckNo',
        width: 300,
      },
      {
        headerName: '登錄號碼',
        field: 'regNo',
        width: 300,
        hide: true,
      },
    ];
  };

  const onFirstDataRendered = (params: any) => {
    // params.api.sizeColumnsToFit();
  };

  const gridRef = useRef<any>(undefined);
  const gridOptions = useMemo<GridOptions>(() => {
    const colDefs: ColDef[] = getColumnDefs(false);

    const options: GridOptions = {
      columnDefs: colDefs,
      defaultColDef: {
        flex: 1,
        minWidth: 120,
        filter: true,
        resizable: true,
        sortable: true,
        editable: false,
      },
      frameworkComponents: {},
      components: {},
      tooltipShowDelay: 1,
      headerHeight: 40,
      rowHeight: 40,
      animateRows: true,
      rowSelection: 'single',
      suppressRowClickSelection: true,
      multiSortKey: 'ctrl',
      localeText: localeTw,
      pagination: true,
      paginationPageSize: 100,
      // colResizeDefault: 'shift',
    };

    return options;
  }, []);

  const onGridReady = (params: any) => {
    // params.api.sizeColumnsToFit();
  };

  const handleSearchDetail = async (regNo: string, containerNo: string) => {
    dispatch(setLoadingRedux(true));

    setOpenSearchField(true);
    setOpenSearchTable(false);
    postApiAndFunctionName(apiName, 'searchCarData', {
      // 修正後的寫法：使用屬性速記
      warehouse: master.warehouse,
      enterTypeOut: master.enterTypeIn === 'Y' ? 'N' : 'Y',
      enterTypeIn: master.enterTypeIn,
      carNo: master.carNo,
      enterDate: master.enterDate,
      containerNo,
      regNo,
    }).then((item) => {
      if (!snackBarRsp(enqueueSnackbar, item) || item.data.status !== 0) {
        dispatch(setLoadingRedux(false));
        return;
      }
      const { data: dataTemp } = item.data;

      const data = dataTemp as Iresult;
      if (data) {
        setDetail(
          cleanNulls({
            ...resultDefaultValue,
            ...data,
          })
        );
      }
    });
    dispatch(setLoadingRedux(false));
    setRandomValue(Math.random());
  };

  const handleSave = async () => {
    dispatch(setLoadingRedux(true));

    postApiAndFunctionName(apiName, 'confirm', {
      warehouse: detail.warehouse,
      enterTypeOut: detail.enterTypeIn === 'Y' ? 'N' : 'Y',
      enterTypeIn: detail.enterTypeIn,
      carNo: detail.carNo,
      regNo: detail.regNo,
      containerNo: detail.containerNo,
      driver: detail.driver,
      driverNo: detail.driverNo,
      driverAide: detail.driverAide,
      driverAideNo: detail.driverAideNo,
      logisticName: detail.logisticName,
      enterStatus: detail.enterStatus,
      remark: detail.remark,
      enterDate: detail.enterDate,
      vasnoNo: detail.vasnoNo,
      truckNo: detail.truckNo,
      actionCode: detail.actionCode,
      loginUser,
    }).then((item) => {
      if (!snackBarRsp(enqueueSnackbar, item) || item.data.status !== 0) {
        dispatch(setLoadingRedux(false));

        setSaveButtonDisabled(false);
        return;
      }
      const data = item.data.data as Iresult;

      if (data) {
        enqueueSnackbar('存檔成功，畫面顯示車號編輯資料!');
        setDetail(data);
      }

      setSaveButtonDisabled(false);
    });

    dispatch(setLoadingRedux(false));
  };

  const handleCopy = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setDetail((prev) => ({
      ...prev,
      enterDate: getDateDayPlus(),
      containerNo: '',
      vasnoNo: '',
      actionCode: 'insert',
    }));
  };
  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    setOpenSearchField(false);
    setOpenSearchTable(false);

    postApiAndFunctionName(apiName, 'searchContainer', {
      warehouse: master.warehouse,
      enterTypeOut: master.enterTypeIn === 'Y' ? 'N' : 'Y',
      enterTypeIn: master.enterTypeIn,
      carNo: master.carNo,
      enterDate: master.enterDate,
      containerNo: master.containerNo,
    }).then((item) => {
      if (!snackBarRsp(enqueueSnackbar, item) || item.data.status !== 0) {
        dispatch(setLoadingRedux(false));
        return;
      }
      const containerNos =
        (item.data.data as { containerNos?: IresultContainerNo[] })
          ?.containerNos ?? [];
      const data: IresultContainerNo[] = containerNos;

      if (data.length > 1) {
        setRowData(data);
        setOpenSearchTable(true);
      } else if (data.length === 1) {
        handleSearchDetail(data[0].regNo, data[0].containerNo);
      }
    });

    dispatch(setLoadingRedux(false));
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setSaveButtonDisabled(true);
    let hasError = false;
    if (master.enterDate.length === 0) {
      master.enterDate = getDateDayPlus();
    }
    switch (submitKey) {
      case 'search':
        handleSearch();

        setSaveButtonDisabled(false);
        break;

      case 'Add':
        handleAdd(null);
        setSaveButtonDisabled(false);
        break;
      case 'copy':
        handleCopy();
        setSaveButtonDisabled(false);
        break;

      case 'searchDetail':
        {
          const selectedNodes = gridRef.current.api.getSelectedNodes();

          // 檢查是否有選取的資料
          if (selectedNodes && selectedNodes.length > 0) {
            // 取得第一筆選取的資料，並確認其型別為 Iresult
            const firstSelectedData: Iresult = selectedNodes[0].data;

            // 將第一筆選取的資料傳入 handleSearchDetail
            handleSearchDetail(
              firstSelectedData.regNo,
              firstSelectedData.containerNo
            );
          } else {
            enqueueSnackbar('請先選擇櫃號資料');
          }
        }
        setSaveButtonDisabled(false);
        break;

      case 'save':
        if (detail) {
          if (!detail.enterTypeIn) {
            enqueueSnackbar('進出站類型必填');
            hasError = true;
          }
          if (detail.enterTypeIn === 'N') {
            if (!detail.carNo) {
              enqueueSnackbar('車號必填');
              hasError = true;
            }
            if (!detail.containerNo) {
              enqueueSnackbar('貨櫃號碼必填');
              hasError = true;
            }
            if (!detail.driver) {
              enqueueSnackbar('司機姓名必填');
              hasError = true;
            }
            if (!detail.driverNo) {
              enqueueSnackbar('司機身份證號必填');
              hasError = true;
            }
            if (!detail.logisticName) {
              enqueueSnackbar('通運公司必填');
              hasError = true;
            }
            if (!detail.enterStatus) {
              enqueueSnackbar('進出站狀態必填');
              hasError = true;
            }
          }
        }
        if (!hasError) {
          handleSave();
        } else {
          setSaveButtonDisabled(false);
        }
        break;

      default:
        setSaveButtonDisabled(false);
        break;
    }
  };
  const updateDataD = async (updateObj: Iobject) => {
    setDetail({ ...detail, ...updateObj });
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      setFormError(warehouseResult.error);
    }
  };

  const fetchMainNoBySubNo = async (subNo: string) => {
    try {
      // 範例：呼叫 API 查主號
      await handleMawb(subNo);
    } catch (err) {
      console.error('查詢主號時發生錯誤:', err);
    }
  };

  const handleHawbBlur = () => {
    if (hawb.trim() === '') return; // 沒輸入就跳出

    // 這裡呼叫你的查詢主號邏輯
    fetchMainNoBySubNo(hawb);
  };

  // 按下查詢圖示
  const handleOpenPopup = () => {
    setOpenPopup(true);
  };

  // 點擊確定後
  const handleConfirm = () => {
    // 這裡留給你自己寫取得新貨櫃號碼的邏輯
    // 例如呼叫 API 或組合字串

    postApiAndFunctionName(apiName, 'findContainerNoByWorkimphwb', {
      warehouse: master.warehouse,
      mawbNo: `${mawb}`,
      hawbNo: `${hawb}`,
    }).then((item) => {
      if (!snackBarRsp(enqueueSnackbar, item) || item.data.status !== 0) {
        return;
      }
      const data: IresultContainerNo[] =
        (item?.data?.data as IresultContainerNo[]) ?? [];

      if (data.length > 0) {
        updateDataD({ containerNo: data[0].containerNo });
        setOpenPopup(false);
      }
    });
  };

  return (
    <div id="page-area">
      {/* <Header guest /> */}
      {userType && <Header />}
      <div className="breadcrumbs-area" />
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 車輛入出站登錄維護
          </div>
        </div>
        <div className="input-area">
          <div>
            {/* 20210325 新增權限判斷 */}
            {userType && master.warehouse && (
              <Grid container>
                <VcEGrid item xs={12} sm={2} className="input-text">
                  <FormTitle>*快遞倉站：</FormTitle>
                </VcEGrid>
                <VcGrid item xs={12} sm={3}>
                  <WarehouseModal
                    value={master.warehouse}
                    updateData={updateData}
                    setStatus={setWarehouseName}
                  />
                </VcGrid>
              </Grid>
            )}
          </div>
          <div>
            <Grid container>
              <VcEGrid
                item
                xs={3}
                sm={2}
                className="input-text"
                style={isXs ? { minWidth: '40%' } : undefined}
              >
                <FormTitle>進出站類型：</FormTitle>
              </VcEGrid>
              <VcGrid item xs={4} sm={2}>
                <Radio
                  className="input-radio "
                  name="enterTypeIn"
                  value={master.enterTypeIn}
                  onChange={(e, value) => {
                    radioChange(updateData)(e, value);
                  }}
                  options={enterTypeInOptions}
                />
              </VcGrid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                <FormTitle>*進出站日期：</FormTitle>
              </VcEGrid>
              <VcGrid item xs={12} sm={5} style={{ maxWidth: 900 }}>
                <DateOneSePickersTyping
                  required
                  updateData={updateData}
                  style={{ maxWidth: 200 }}
                  inputDataName="enterDate"
                  data={master}
                  seInterval={31}
                />
              </VcGrid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                車號：
              </VcEGrid>
              <Grid item xs={12} sm={2}>
                <Input
                  maxLength={8}
                  value={master.carNo}
                  name="carNo"
                  onChange={(e) => {
                    // 取得當前的輸入值
                    const inputValue = e.target.value;
                    // 將值轉換為大寫
                    e.target.value = inputValue.toUpperCase();
                    // 呼叫你的 inputChange 函式
                    inputChange(updateData)(e);
                  }}
                />
              </Grid>
            </Grid>
          </div>
          <div>
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                櫃號：
              </VcEGrid>
              <Grid item xs={12} sm={2}>
                <Input
                  maxLength={17}
                  value={master.containerNo || ''}
                  name="containerNo"
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </Grid>
            </Grid>
          </div>

          {/* <div>
            <div>{screenType}</div>
            {isXs && '目前為 xs 螢幕'}
            {isSm && '目前為 sm 螢幕'}
            {!isXs && !isSm && '目前為 md 以上螢幕'}
          </div> */}
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          {openSearchTable && (
            <Grid item xs={12} sm="auto">
              <Button
                disabled={formError}
                type="submit"
                variant="contained"
                color="primary"
                startIcon={<SaveIcon />}
                onClick={() => setSubmitKey('searchDetail')}
              >
                確定
              </Button>
            </Grid>
          )}

          {!openSearchTable && (
            <Grid item xs={12} sm="auto">
              <Button
                disabled={formError}
                type="submit"
                variant="contained"
                color="primary"
                startIcon={<SaveIcon />}
                onClick={() => setSubmitKey('Add')}
              >
                新增
              </Button>
            </Grid>
          )}
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
        </Grid>
        <div
          style={{
            color: 'red',
            fontWeight: 800,
            marginLeft: '10%',
            padding: 0,
          }}
        >
          車號格式；請輸入英文及數字ex:AB1234
        </div>

        {openSearchField && (
          <>
            <form>
              <div style={{ height: 24 }} />
              <div>
                <Grid container>
                  <VcEGrid
                    item
                    xs={12}
                    sm={12}
                    className="input-text"
                    style={{
                      fontWeight: 'bold',
                      color: 'blue',
                      fontSize: '1.3rem',
                      justifyContent: 'flex-start',
                    }}
                  >
                    {detail.actionCode === 'insert'
                      ? '現在為新增模式，輸入完成請按[確定]'
                      : '現在為修改模式，修改完成請按[確定]'}
                  </VcEGrid>
                </Grid>
              </div>
            </form>
          </>
        )}
        {openSearchField && (
          <>
            <div
              style={{
                display: 'flex', // 父容器設為 Flexbox
                flexDirection: 'row', // 子項目水平排列
                justifyContent: 'flex-start', // 子項目靠左對齊
              }}
            >
              <form
                className="form-area"
                style={{
                  width: '100%', // 相當於 col-8
                  display: 'flex', // 相當於 d-flex
                  flexDirection: 'row', // 相當於 flex-column
                  justifyContent: 'flex-start', // 相當於 justify-content-start
                }}
              >
                {/* 左邊的輸入欄位區塊 */}
                <div style={{ flexGrow: 1, marginRight: '20px' }}>
                  {/* 第一行 (單獨一行) */}
                  <div>
                    <Grid container alignItems="center">
                      <VcEGrid item xs={6} sm={2} className="input-text">
                        <FormTitle>進出站類型：</FormTitle>
                      </VcEGrid>
                      <HVcGrid item xs={6} sm={2}>
                        <Radio
                          className="input-radio "
                          required
                          name="enterTypeIn"
                          value={detail.enterTypeIn}
                          onChange={(e, value) => {
                            radioChange(updateDataD)(e, value);
                          }}
                          options={enterTypeInOptions}
                        />
                      </HVcGrid>
                    </Grid>
                  </div>

                  {/* 中間的輸入欄位區塊 (與 QRCode 並排) */}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <div>
                      <Grid container>
                        <VcEGrid item xs={6} sm={2} className="input-text">
                          <FormTitle>*進出站日期：</FormTitle>
                        </VcEGrid>
                        <VcGrid item xs={6} sm={5} style={{ maxWidth: 900 }}>
                          <DateOneSePickersTyping
                            required
                            updateData={updateDataD}
                            style={{ maxWidth: 200 }}
                            inputDataName="enterDate"
                            data={detail}
                            seInterval={31}
                          />
                        </VcGrid>
                      </Grid>
                    </div>
                    <div>
                      <Grid container>
                        <VcEGrid item xs={6} sm={2} className="input-text">
                          <FormTitle>*車號：</FormTitle>
                        </VcEGrid>
                        <Grid item xs={6} sm={2}>
                          <Input
                            maxLength={8}
                            value={detail.carNo}
                            name="carNo"
                            onChange={(e) => {
                              inputChange(updateDataD)(e);
                            }}
                          />
                        </Grid>
                      </Grid>
                    </div>
                    <div>
                      <Grid container>
                        <VcEGrid item xs={6} sm={2} className="input-text">
                          <FormTitle>*貨櫃號碼：</FormTitle>
                        </VcEGrid>
                        <Grid item xs={6} sm={2}>
                          <Autocomplete
                            freeSolo
                            options={containerNoOptions}
                            value={detail.containerNo}
                            onChange={(_, newValue) => {
                              updateDataD({
                                containerNo: newValue || '',
                              });
                            }}
                            onInputChange={(_, newInputValue) => {
                              updateDataD({
                                containerNo: newInputValue || '',
                              });
                            }}
                            renderInput={(params) => (
                              <Input
                                {...params}
                                name="containerNo"
                                value={detail.containerNo}
                              />
                            )}
                          />
                          <IconButton
                            onClick={handleOpenPopup}
                            size="small"
                            title="查詢貨櫃號碼"
                            style={{ marginLeft: 4 }}
                          >
                            <SearchIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </div>

                    {/* 小視窗 Popup */}
                    <Dialog
                      open={openPopup}
                      onClose={() => setOpenPopup(false)}
                    >
                      <DialogTitle>查詢貨櫃號碼</DialogTitle>
                      <DialogContent dividers>
                        <Grid container spacing={2}>
                          <VcEGrid item xs={12} sm={3} className="input-text">
                            <FormTitle>分號：</FormTitle>
                          </VcEGrid>
                          <Grid item xs={12} sm={9}>
                            <TextField
                              value={hawb}
                              onChange={(e) => setHawb(e.target.value)}
                              onBlur={handleHawbBlur}
                              fullWidth
                            />
                          </Grid>
                          <Grid container spacing={2}>
                            <VcEGrid item xs={12} sm={3} className="input-text">
                              <FormTitle>主號：</FormTitle>
                            </VcEGrid>
                            <Grid item xs={12} sm={9}>
                              <Autocomplete
                                fullWidth
                                freeSolo
                                options={mawbOptions}
                                value={mawb}
                                onChange={(_, newValue) => {
                                  setMawb(newValue || '');
                                }}
                                onInputChange={(_, newInputValue) => {
                                  setMawb(newInputValue || '');
                                }}
                                renderInput={(params) => (
                                  <Input {...params} name="mawb" />
                                )}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={() => setOpenPopup(false)}>
                          取消
                        </Button>
                        <Button variant="contained" onClick={handleConfirm}>
                          確定
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </div>

                  {/* 第四行 (單獨一行) */}
                  <div>
                    <Grid container>
                      <VcEGrid item xs={6} sm={2} className="input-text">
                        <FormTitle>*司機姓名：</FormTitle>
                      </VcEGrid>
                      <Grid item xs={6} sm={2}>
                        <Input
                          maxLength={16}
                          value={detail.driver}
                          name="driver"
                          onChange={(e) => {
                            inputChange(updateDataD)(e);
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container>
                      <VcEGrid item xs={6} sm={2} className="input-text">
                        <FormTitle>*司機身份證號：</FormTitle>
                      </VcEGrid>
                      <Grid item xs={6} sm={2}>
                        <Input
                          maxLength={12}
                          value={detail.driverNo}
                          name="driverNo"
                          onChange={(e) => {
                            inputChange(updateDataD)(e);
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container>
                      <VcEGrid item xs={6} sm={2} className="input-text">
                        助手姓名：
                      </VcEGrid>
                      <Grid item xs={6} sm={2}>
                        <Input
                          maxLength={16}
                          value={detail.driverAide}
                          name="driverAide"
                          onChange={(e) => {
                            inputChange(updateDataD)(e);
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container>
                      <VcEGrid item xs={6} sm={2} className="input-text">
                        助手身份證號：
                      </VcEGrid>
                      <Grid item xs={6} sm={2}>
                        <Input
                          maxLength={12}
                          value={detail.driverAideNo}
                          name="driverAideNo"
                          onChange={(e) => {
                            inputChange(updateDataD)(e);
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container>
                      <VcEGrid item xs={6} sm={2} className="input-text">
                        <FormTitle>*通運公司：</FormTitle>
                      </VcEGrid>
                      <Grid item xs={6} sm={2}>
                        <Input
                          maxLength={50}
                          value={detail.logisticName}
                          name="logisticName"
                          onChange={(e) => {
                            inputChange(updateDataD)(e);
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container>
                      <VcEGrid item xs={6} sm={2} className="input-text">
                        <FormTitle>*進出站狀態：</FormTitle>
                      </VcEGrid>
                      <Grid item xs={6} sm={2}>
                        <Select
                          // placeholder="請先填入分號"
                          value={detail.enterStatus}
                          onChange={selectChange(updateDataD)}
                          name="enterStatus"
                          options={enterstatusOptions}
                        />
                      </Grid>
                    </Grid>
                    <Grid container>
                      <VcEGrid item xs={6} sm={2} className="input-text">
                        備註：
                      </VcEGrid>
                      <Grid item xs={6} sm={2}>
                        <Input
                          maxLength={50}
                          value={detail.remark}
                          name="remark"
                          onChange={(e) => {
                            inputChange(updateDataD)(e);
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container>
                      <VcEGrid item xs={6} sm={2} className="input-text">
                        板箱號：
                      </VcEGrid>
                      <Grid item xs={6} sm={2}>
                        <Input
                          maxLength={4}
                          value={detail.truckNo}
                          name="truckNo"
                          onChange={(e) => {
                            inputChange(updateDataD)(e);
                          }}
                        />
                      </Grid>
                    </Grid>
                  </div>
                </div>

                {/* 右邊的 QRCode 區塊 */}
                {detail.regNo && detail.actionCode !== 'insert' && (
                  <Hidden smDown>
                    <div
                      style={{
                        flexShrink: 0,
                        width: '30%', // 設定 QRCode 區塊的寬度
                      }}
                    >
                      <QRCodeCanvas value={detail.regNo} size={200} />
                    </div>
                  </Hidden>
                )}
              </form>
            </div>

            {detail.regNo && detail.actionCode !== 'insert' && (
              <Hidden mdUp>
                <div
                  style={{
                    flexShrink: 0,
                    width: '100%', // 設定 QRCode 區塊的寬度
                  }}
                >
                  <QRCodeCanvas value={detail.regNo} size={200} />
                </div>
              </Hidden>
            )}
            {openSearchField && (
              <>
                <Grid container className="button-area">
                  <VcEGrid item xs={12} sm={2}>
                    <Button
                      disabled={formError || saveButtonDisabled}
                      type="submit"
                      variant="contained"
                      color="primary"
                      startIcon={<SaveIcon />}
                      onClick={() => setSubmitKey('save')}
                    >
                      確定
                    </Button>
                  </VcEGrid>
                  <Grid item xs={12} sm="auto">
                    <Button
                      disabled={formError || !!(detail.actionCode === 'insert')}
                      type="submit"
                      variant="contained"
                      color="primary"
                      startIcon={<FileCopy />}
                      onClick={() => setSubmitKey('copy')}
                    >
                      複製
                    </Button>
                  </Grid>
                </Grid>
              </>
            )}
          </>
        )}
      </form>

      {openSearchTable && (
        <div className="ag-theme-alpine" style={{ height: '400px' }}>
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            gridOptions={gridOptions}
            onGridReady={onGridReady}
            onFirstDataRendered={onFirstDataRendered}
          />
        </div>
      )}
    </div>
  );
};

export default CarRegisterMtn;
